export const colourPickerContainerStyle = {
	width: 'auto',
	padding: '15px',
	background: 'white',
	border: '0px solid rgba(0, 0, 0, 0.25)',
	boxShadow: 'rgb(0 0 0 / 25%) 0px 1px 4px',
	right: '0',
	bottom: '0',
	borderRadius: '4px',
	margin: '0 15px 15px 0',
	position: 'fixed',
	zIndex: '1',
};

export const colourPickerHeadingStyle = {
	color: '#000',
	fontFamily: 'Raleway',
	fontWeight: '600',
	marginBottom: '0',
};

export const colourPickerCardStyle = {
	default: {
		card: {
			border: 'none',
			boxShadow: 'none',
			borderRadius: '0',
			width: '100%',
		},
		input: {
			display: 'none',
		},
		hash: {
			display: 'none',
		},
		body: {
			padding: '8px 0px 0px 0px',
		},
	},
};
